//global

import {EventEmitter, isTouch} from 'a-utils';
// import {ScrollViewElement, ScrollHandler, ScrollEvent} from './scroll-view.component';

const eventEmitter = new EventEmitter<ScrollData>();
// let eventEmitter = new EventEmitter<ScrollEvent, ScrollHandler>();


export type ScrollData = {
  type: 'change' | undefined,
  _module: 'scroll.store'
} & ScrollPosition;

export type ScrollPosition = {
  top: number;
  left: number;
  height: number;
}


let initialized: boolean = false;

const position: ScrollPosition = {
  top: 0,
  left: 0,
  height: 1
}




function _scrollPositionTop() {
  let position = window.pageYOffset;
  if (isNaN(position)) position = 0;
  return Math.max(position, 0);
}
function _scrollPositionLeft() {
  let position = window.pageXOffset;
  if (isNaN(position)) position = 0;
  return position;
}

function _change() {
  position.top  = _scrollPositionTop();
  position.left = _scrollPositionLeft();
  // position.height =

  //@ts-ignore
  eventEmitter.dispatch(_getData('change'));
}


function _getData(type?: 'change'): ScrollData {
  return {
    type: type,
    _module: 'scroll.store',
    ...position
  }
}



function _init() {
  position.top  = _scrollPositionTop();
  position.left = _scrollPositionLeft();

  // const scrollView = document.querySelector<ScrollViewElement>('scroll-view');

  // if (scrollView && !isTouch()) {
  //   // scrollView.addListener((pos) => {
  //   //   position.top = pos.top;
  //   //   position.left = pos.left;
  //   //
  //   //   eventEmitter.dispatch(_getData('change'));
  //   // });
  //
  //   // eventEmitter = scrollView.eventEmitter;
  //
  // } else {
  window.addEventListener('scroll', _change, false);
  // }


  // requestAnimationFrame = utils.getRequestAnimationFrame();
  // _loop();

  initialized = true;
}


if (!initialized) _init();

export default {
  eventEmitter: eventEmitter,
  getData: _getData.bind(null, undefined)
};
